// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.line-divider {
  margin-left: 2em;
  margin-right: 1em;
}

.flex-message-row {
  display: flex;
  flex-grow: 1;
}

.custom-no-records-info {
  font-size: 14px;
  color: #000000 !important;
}

.custom-table-header {
  color: #fff;
  background-color: var(--undp-jtf-accent-color);
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/messages/components/messages.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,YAAA;AAEF;;AACA;EACE,eAAA;EACA,yBAAA;AAEF;;AACA;EACE,WAAA;EACA,8CAAA;EACA,uBAAA;AAEF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../scss/variables';\n\n.line-divider {\n  margin-left: 2em;\n  margin-right: 1em;\n}\n\n.flex-message-row {\n  display: flex;\n  flex-grow: 1;\n}\n\n.custom-no-records-info {\n  font-size: 14px;\n  color: #000000 !important;\n}\n\n.custom-table-header {\n  color: #fff;\n  background-color: var(--undp-jtf-accent-color);\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
